'use client';

import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from '@/store/hooks';
import { selectAlertasBadge } from '../store/saudeIntegracoes';
export function IntegracaoAlertasBadge() {
  const $ = _c(3);
  const {
    count,
    temCritico
  } = useAppSelector(selectAlertasBadge);
  if (count === 0) {
    return null;
  }
  const colorClass = temCritico ? "bg-error-500" : "bg-warning-500";
  const t0 = `flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white ${colorClass}`;
  let t1;
  if ($[0] !== count || $[1] !== t0) {
    t1 = <span className={t0}>{count}</span>;
    $[0] = count;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}